import Nullstack from 'nullstack';
export default function IconRuler({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ruler",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 4h14a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "8",
    x2: "6",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "12",
    x2: "7",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "16",
    x2: "6",
    y2: "16"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "4",
    x2: "8",
    y2: "6"
  }), "   ", Nullstack.element("polyline", {
    points: "12 4 12 7 "
  }), "   ", Nullstack.element("polyline", {
    points: "16 4 16 6 "
  }), " ");
}